import Config from '@config';
import { initializeSubdivisionsApi } from '@gasbi/shared/common/features/subdivisions';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  subdivisionsApi,
  useGetSubdivisionByIdQuery,
  useCreateSubdivisionMutation,
  useUpdateSubdivisionByIdMutation,
  useAssignRepresentativeToSubdivisionMutation,
  useUnassignRepresentativeFromSubdivisionMutation,
  useAssignSignatoryToSubdivisionMutation,
  useUnassignSignatoryFromSubdivisionMutation,
  useGetSubdivisionsInfiniteQuery,
  useGetCachedSubdivisionByIdSelector,
} = initializeSubdivisionsApi(Config.VITE_API_CLIENT_URL, axiosBaseQuery);
